"use client"

import React from 'react';
import {useAppStore} from "@/store/AppStore";
import {Link} from "@/i18n/routing";
import {FaPrayingHands} from "react-icons/fa";
import {GiKnifeFork, GiNightSleep} from "react-icons/gi";
import {Chip} from "@mui/material";

export default function PlaceCategory(props: { id: string, className: string }) {
  const cats = useAppStore((state) => {
    return state.cats
  })

  const cat = cats?.filter(cat => {
    return String(cat.id) === props.id
  })

  if (!cat || cat.length === 0) return null
  const currentCat = cat.pop()
  if (!currentCat) return null

  const icon = (cat: string) => {
    switch (cat) {
      case 'Pregare':
        return <FaPrayingHands/>
      case 'Mangiare':
        return <GiKnifeFork/>
      case 'Dormire':
        return <GiNightSleep/>
    }

  }

  return <Link className={props.className}
               href={`/places/?category=${currentCat.id}`}>
    <Chip icon={icon(currentCat.name)} size={"small"}
          label={currentCat.name}
          color="primary"
          variant="outlined"/></Link>
}
